import dayjs from 'dayjs';

/**
 * Expressão Regular para identificar strings de data nos formatos ISO 8601.
 * Inclui o formato completo (com tempo e fuso horário, ex: 2025-08-18T14:14:49.000000Z)
 * e o formato de data pura (ex: 2025-08-19).
 */
const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3,6})?Z?)?$/;

/**
 * Formata uma data no padrão ISO (YYYY-MM-DD) com ou sem hora.
 *
 * @param {string} rawDate - Data no formato "YYYY-MM-DD HH:mm:ss"
 * @param {boolean} showTime - Se true, inclui hora no formato
 * @returns {string} - Data formatada
 */
export function formatDate({ rawDate, showTime = false }) {
    if (!rawDate) return '';

    const formatted = dayjs(rawDate).format(showTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD');
    return formatted;
}

export function formatDateFront({ rawDate, showTime = false }) {
    if (!rawDate) return '';

    // Altere a string de formato para 'DD/MM/YYYY'
    const formatString = showTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY';

    const formatted = dayjs(rawDate).format(formatString);
    return formatted;
}

/**
 * Formata datas de calendário sem aplicar conversão de fuso horário.
 * Campos como data de compra representam um dia, não um instante no tempo.
 */
export function formatDateOnlyFront({ rawDate }) {
    if (!rawDate) return '';

    const dateOnly = typeof rawDate === 'string'
        ? rawDate.match(/^(\d{4})-(\d{2})-(\d{2})/)
        : null;

    if (dateOnly) return `${dateOnly[3]}/${dateOnly[2]}/${dateOnly[1]}`;

    return formatDateFront({ rawDate });
}

/**
 * Percorre recursivamente um objeto, identifica strings de data e as formata usando Day.js.
 * @param {object} obj O objeto a ser processado.
 * @returns {object} O objeto com as datas formatadas.
 */
export function formatDatesInObject(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map((item) => formatDatesInObject(item));
    }

    const newObj = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];

            // Usa a Regex para identificar a string de data
            if (typeof value === 'string' && ISO_DATE_REGEX.test(value)) {
                newObj[key] = formatDateFront({ rawDate: value });
            } else if (typeof value === 'object') {
                newObj[key] = formatDatesInObject(value);
            } else {
                newObj[key] = value;
            }
        }
    }
    return newObj;
}
